import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO:
 */
export const getEntitiesForGroups = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.getGroupsWithEntities.relay((forwardTo, { groupIds }) =>
      feature.selectors.getGroupsWithEntityIds({ groupIds }).asObservable.pipe(
        rxjs.map(groups => {
          const distinctEntityIds = new Set<ecModels.EntityId>(
            groups.flatMap(group => group.entityIds),
          )

          return forwardTo(
            plugin.collection.plugins.dataOperationPlugin.feature.actions.list,
            {
              input: { ids: Array.from(distinctEntityIds) },
              output: ({ response }) => {
                // Creates a lookup to use when composing the groups
                const entityLookup: Partial<
                  Record<ecModels.EntityId, TTypeParams['entity']>
                > = {}
                for (const entity of response.entities) {
                  entityLookup[plugin.collection.identify(entity)] = entity
                }
                return {
                  groups: groups.map(group => ({
                    ...group,
                    entities: group.entityIds.map(id => entityLookup[id]),
                  })),
                }
              },
            },
          )
        }),
      ),
    ).asObservable,
)
